import PropTypes from "prop-types";
import classNames from "classnames";
import { getHeaderTitle } from "../helpers.js";
import styles from "./CategoryHeaderTitle.css";

const CategoryHeaderTitle = ({
  category: { headerTitle, friendlyName, headerHtmlEncoded },
  hasVisualCategories
}) => {
  const header = getHeaderTitle({
    headerTitle,
    friendlyName,
    headerHtmlEncoded
  });

  const titleClassName = classNames(styles.categoryHeaderTitle, {
    [styles.categoryHeaderTitleWithVisualCategories]: hasVisualCategories
  });

  return (
    <h1
      className={titleClassName}
      dangerouslySetInnerHTML={{
        __html: header
      }}
    />
  );
};

CategoryHeaderTitle.propTypes = {
  category: PropTypes.shape({
    headerTitle: PropTypes.string,
    friendlyName: PropTypes.string.isRequired,
    headerHtmlEncoded: PropTypes.string.isRequired
  }).isRequired,
  hasVisualCategories: PropTypes.bool
};

export default CategoryHeaderTitle;
